<script>
  import {
    required,
    email,
    helpers
  } from "@vuelidate/validators";
  import appConfig from "../../../app.config";
  import axios from 'axios';

  export default {
    page: {
      title: "Login",
      meta: [{
        name: "description",
        content: appConfig.description,
      }, ],
    },
    data() {
      return {
        email: null,
        password: null,
        submitted: false,
        authError: null,
        tryingToLogIn: false,
        isAuthError: false,
        errormesj: false,
        typeMsj: false,
      };
    },

    // email: "admin@themesbrand.com",
    // password: "123456",

    validations: {
      email: {
        required: helpers.withMessage("Email is required", required),
        email: helpers.withMessage("Please enter valid email", email),
      },
      password: {
        required: helpers.withMessage("Password is required", required),
      },
    },

    mounted(){
      // console.log(this.$route.query.confirmation);
    },
    
    computed: {

    },
    methods: {

      async signinapi() {
        if(this.email == null||this.password ==null){
          console.log('no input');
        }else{
          // console.log('czc');
          const result = await axios.post(process.env.VUE_APP_API_BASEURL+'login', {
            email: this.email,
            password: this.password
          })

          if (result.data.status == 'fail') {
              this.errormesj = result.data.message;
              this.typeMsj = result.data.type;
              return this.authError = result.data.data;
          }else if(result.data.status == 'success'){
              localStorage.setItem('jwt', result.data.token);
              localStorage.setItem('role', result.data.role_id);

              axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
              axios.get(process.env.VUE_APP_API_BASEURL+'menu/my')
              .then(response => {
                  localStorage.setItem('menus', JSON.stringify(response.data));
                  // JSON.stringify
                  // console.log(response.data);
                  // console.log(localStorage.getItem('menus'));
              });
              if(this.$route.query.redirectFrom){
                this.$router.push({
                    
                    path: this.$route.query.redirectFrom
                });
              }else{
                this.$router.push({
                    
                    path: '/'
                });
              }
          }
          
        }
      }
    },
  };
</script>

<template>
  <div class="auth-page-wrapper pt-5">
    <!-- auth page bg -->
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div class=""></div>

            <div class="shape">

                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                </svg>
            </div>
            <Particles id="tsparticles" :options="{
          particles: {
            number: {
              value: 90,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: '#ffffff',
            },
            shape: {
              type: 'circle',
              stroke: {
                width: 0,
                color: '#000000',
              },
              polygon: {
                nb_sides: 5,
              },
              image: {
                src: 'img/github.svg',
                width: 100,
                height: 100,
              },
            },
            opacity: {
              value: 0.8,
              random: true,
              anim: {
                enable: true,
                speed: 1,
                opacity_min: 0,
                sync: false,
              },
            },
            size: {
              value: 4,
              random: true,
              anim: {
                enable: false,
                speed: 4,
                size_min: 0.2,
                sync: false,
              },
            },
            line_linked: {
              enable: false,
              distance: 150,
              color: '#ffffff',
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 2,
              direction: 'none',
              random: false,
              straight: false,
              out_mode: 'out',
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: 'canvas',
            events: {
              onhover: {
                enable: true,
                mode: 'bubble',
              },
              onclick: {
                enable: true,
                mode: 'repulse',
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 4,
                duration: 2,
                opacity: 0.8,
                speed: 3,
              },
              repulse: {
                distance: 200,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
          config_demo: {
            hide_card: false,
            background_color: '#b61924',
            background_image: '',
            background_position: '50% 50%',
            background_repeat: 'no-repeat',
            background_size: 'cover',
          },
        }" />
        </div>

    <!-- auth page content -->
    <div class="auth-page-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mt-sm-5 mb-4 text-white-50">
              <!--div>
                <router-link to="/" class="d-inline-block auth-logo">
                  <img src="@/assets/images/renewp_logo.png" alt=""/>
                </router-link>
              </div-->
              <!--p class="mt-3 fs-15 fw-medium">
                Sell Your Device With Easy way in Microsite 
              </p-->
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card mt-4">
              <div class="card-body p-4">
                <div class="text-center mt-2">
                  <div>
                    <router-link to="/" class="d-inline-block auth-logo">
                      <img src="@/assets/images/renewp_logo.png" alt=""/>
                    </router-link>
                  </div>
                  <br>
                  <p class="text-muted">Sign in to continue with Renew+.</p>
                </div>
                <div class="p-2 mt-4">
                  <b-alert v-model="authError" variant="danger" class="mt-3" dismissible>{{ authError }}</b-alert>

                  <div>

                  </div>

                  <form @submit.prevent="tryToLogIn">
                    <div class="mb-3">
                      <label for="email" class="form-label">Email</label>
                      <input type="email" class="form-control" id="email" placeholder="Enter email" v-model="email" required/>
                      <div class="invalid-feedback">
                        <span></span>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="float-end">
                        <router-link to="/forgot-password" class="text-muted">Forgot
                          password?</router-link>
                      </div>
                      <label class="form-label" for="password-input">Password</label>
                      <div class="position-relative auth-pass-inputgroup mb-3">
                        <input type="password" v-model="password" class="form-control pe-5" placeholder="Enter password"
                          id="password-input" required/>
                        <!-- <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                          type="button" id="password-addon">
                          <i class="ri-eye-fill align-middle"></i>
                        </button> -->
                        <div class="invalid-feedback">
                          <span></span>
                        </div>
                      </div>
                    </div>

                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                      <label class="form-check-label" for="auth-remember-check">Remember me</label>
                    </div>
                    <br>
                    <div v-if="errormesj">
                        <div class="alert alert-warning alert-border-left alert-dismissible fade show" role="alert">
                            <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>{{ this.errormesj }}</strong>
                            <!-- {{ this.errormesj }} -->
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    </div>
                    <div v-if='$route.query.confirmation'>
                        <div class="alert alert-success alert-border-left alert-dismissible fade show" role="alert">
                            <i class="ri-alert-line me-3 align-middle fs-16"></i><strong> Email successfully verified</strong>
                            
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    </div>

                    <div class="mt-4">
                      <button class="btn btn-success w-100" type="submit" @click="signinapi">
                        Sign In
                      </button>

                    </div>
                    <!--div class="mt-4 text-center">
                          <p class="mb-0">Don't have an account ? <router-link to="/auth/signup-cover" class="fw-semibold text-primary text-decoration-underline"> Signup </router-link> </p>
                      </div-->
                  </form>
                </div>
              </div>
              <!-- end card body -->
            </div>
            <!-- end card -->

            <div class="mt-4 text-center">
              <!-- <p class="mb-0">
                Don't have an account ?
                <router-link to="/register" class="fw-semibold text-primary
                  text-decoration-underline">
                  Signup
                </router-link>
              </p> -->
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end auth page content -->

    <!-- footer -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center">
              <p class="mb-0 text-muted"> &copy; {{ new Date().getFullYear() }} CompAsia. All Rights Reserved </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- end Footer -->
  </div>
  <!-- end auth-page-wrapper -->
</template>